import { Section } from '../layout/Section';
import { Pill } from '../ui/Pill';
import { Picture } from '../ui/Picture';
import { Icon } from '../ui/Icon';
import { Reveal } from '../ui/Reveal';
import { about, hero } from '../../data/landing';
import styles from './About.module.css';

export function About() {
  const { growth } = hero.stats;

  return (
    <Section id="about">
      <div className={styles.grid}>
        <Reveal className={styles.media} variant="left">
          <Picture
            name="about-lobby"
            alt="Guests checking in at a hotel reception desk"
            ratio="460 / 530"
            sizes="(max-width: 1023px) 92vw, 460px"
            className={styles.photo}
          />

          <div className={styles.statCard}>
            <div className={styles.statHead}>
              <Icon name="chart-histogram" size={22} />
              <span className={styles.statTitle}>{growth.title}</span>
            </div>

            <div className={styles.statRow}>
              <span className={styles.statValue}>{growth.value}</span>
              <span className={styles.delta}>{growth.delta}</span>
            </div>

            <div className={styles.meter} aria-hidden="true">
              <div className={styles.meterFill} />
            </div>

            <p className={styles.todayLabel}>
              <span className={styles.todayDot} aria-hidden="true" />
              {growth.todayLabel}
            </p>
            <p className={styles.today}>{growth.today}</p>
          </div>
        </Reveal>

        <Reveal className={styles.copy} variant="right" delay={0.08}>
          <Pill tone="muted">{about.eyebrow}</Pill>
          <h2 className={`${styles.title} u-display u-gradient-text`}>{about.title}</h2>
          <p className={`${styles.body} u-body-lg`}>{about.body}</p>

          <ul className={styles.tags}>
            {about.tags.map((tag) => (
              <li key={tag}>
                <Pill tone="muted">{tag}</Pill>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </Section>
  );
}
